import template from './signoTec.html';
import { SignoTecController } from './signoTec.controller';

export const signoTecComponent = {
  name: 'signoTec',
  restrict: 'E',
  transclude: true,
  template,
  controllerAs: 'vm',
  controller: SignoTecController,
  bindings: {
    'onConnectionFailed': '&',
    'onSkip': '&',
  }
};
